export { InMemoryCache, defaultDataIdFromObject, } from './inMemoryCache';
export * from './readFromStore';
export * from './writeToStore';
export * from './fragmentMatcher';
export * from './objectCache';
export * from './recordingCache';
//# sourceMappingURL=index.js.map